import { getAxiosClientWithJWTToken } from "api";
import { searchUUIDType } from "redux/slice/reportSlice";

export const getReport = (params: searchUUIDType) =>{
    return getAxiosClientWithJWTToken().get("report", { params });
}